import request from '@/utils/request'


//查询列表
export function photoList(data) {
  return request({
    url: '/admin/photo/list',
    method: 'post',
    data:data
  })
}

//添加
export function photoAdd(data) {
  return request({
    url: '/admin/photo/add',
    method: 'post',
    data:data
  })
}

//修改
export function photoUpdate(data) {
  return request({
    url: '/admin/photo/update',
    method: 'post',
    data:data
  })
}

//删除
export function photoDelete(params) {
  return request({
    url: '/admin/photo/deleteById',
    method: 'get',
    params: params
  })
}





// WEBPACK FOOTER //
// ./src/api/storeFrontPhoto.js